import React, { useState } from 'react';
import { exploreLocations, exploreEffects, exploreColors } from '../mock';

const tabs = [
  { key: 'locations', label: 'Locations' },
  { key: 'effects', label: 'Effects' },
  { key: 'colors', label: 'Colors' },
];

export default function ExploreCollections() {
  const [active, setActive] = useState('locations');
  const data = active === 'locations' ? exploreLocations : active === 'effects' ? exploreEffects : exploreColors;

  return (
    <section className="w-full bg-white py-20 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <div className="text-[11px] tracking-[0.4em] uppercase text-[#7a1a2a] mb-3">Collections</div>
            <h2 className="serif text-4xl md:text-5xl font-light text-[#1a1a1a]">Explore Premium Tiles Collection</h2>
          </div>
          <div className="flex gap-8 border-b border-neutral-200">
            {tabs.map((t) => (
              <button
                key={t.key}
                onClick={() => setActive(t.key)}
                className={`pb-3 text-sm uppercase tracking-[0.2em] transition-colors relative ${active === t.key ? 'text-[#7a1a2a]' : 'text-[#6b6b6b] hover:text-[#1a1a1a]'}`}
              >
                {t.label}
                {active === t.key && <span className="absolute bottom-[-1px] left-0 right-0 h-[2px] bg-[#7a1a2a]" />}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {data.map((item) => (
            <a href="#" key={item.name} className="group relative block img-zoom h-64 md:h-80 bg-neutral-200">
              <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between text-white">
                <span className="serif text-2xl md:text-3xl font-light">{item.name}</span>
                <span className="opacity-0 group-hover:opacity-100 translate-x-[-8px] group-hover:translate-x-0 transition-all text-sm tracking-wider">&rarr;</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
